(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["on-cart"] && !Shopify.designMode) return;
  try {
    /* Omgång 35: en prisruta vars delar alla saknar innehåll döljs. Gäller främst
     Delbetalning (Shopifys payment_terms), som är tom när beloppet eller marknaden
     inte kvalificerar; hamnar den ensam mellan två block blev det en tom ruta.
     Mäts bara när lådan syns (stängd låda = allt 0 px). setTimeout, ingen
     MutationObserver: lådan ritas om vid varje korgändring. */
  (function () {
    function check() {
      document.querySelectorAll('.on-cart-seg.cart-totals').forEach(function (box) {
        if (!box.closest('dialog[open]') && !box.offsetParent) return;
        var kids = Array.prototype.filter.call(box.children, function (c) { return c.tagName !== 'STYLE' && c.tagName !== 'SCRIPT'; });
        var tom = kids.length > 0 && kids.every(function (c) { return c.getBoundingClientRect().height < 2; });
        box.classList.toggle('on-seg-empty', tom);
      });
      spacing();
    }
    /* Omgång 56: eget avstånd per block. Blocket bär data-sp-t/-b (px) och data-sp-f (kant i
       kant med nästa). Lådans block ligger i olika omslag med olika gap, så avståndet mäts
       i stället för att räknas: blockets yttersta element (det högsta som bara innehåller
       blocket) får den marginal som ger exakt det valda avståndet till grannen. Två varv,
       eftersom marginaler i blockflöde kan slås ihop. Bara när lådan syns. */
    var STACK = '.cart-drawer__summary, .cart-summary__inner, .cart-drawer__items, .on-cart-rail, .on-cart-lead, .cart-drawer__content';
    function vis(el) { return el && !/^(STYLE|SCRIPT|TEMPLATE|LINK)$/.test(el.tagName) && el.getBoundingClientRect().height > 0; }
    function outer(el) {
      var b = el;
      while (b.parentElement && !b.parentElement.matches(STACK)) {
        var kids = Array.prototype.filter.call(b.parentElement.children, vis);
        if (kids.length !== 1) break;
        b = b.parentElement;
      }
      return b;
    }
    /* Grannen: närmaste synliga syskon, annars förälderns (blocket kan ligga sist i en rad
       och grannen först i nästa). Aldrig förbi summeringen eller produktytan. */
    var TOP = '.cart-drawer__summary, .cart-summary__inner, .cart-drawer__items, .cart-drawer__content';
    function sib(el, dir) {
      var e = el;
      while (e) {
        var s = dir < 0 ? e.previousElementSibling : e.nextElementSibling;
        while (s && !vis(s)) s = dir < 0 ? s.previousElementSibling : s.nextElementSibling;
        if (s) return s;
        if (e.parentElement && e.parentElement.matches(TOP)) return null;
        e = e.parentElement;
      }
      return null;
    }
    function spacing() {
      var marks = document.querySelectorAll('[data-on-sp]');
      if (!marks.length) return;
      var boxes = [];
      marks.forEach(function (m) {
        if (!m.closest('dialog[open]') && !m.offsetParent) return;
        var b = outer(m);
        if (b.__onSp) { b.style.marginTop = b.__onSp[0]; b.style.marginBottom = b.__onSp[1]; }
        else b.__onSp = [b.style.marginTop, b.style.marginBottom];
        boxes.push([m, b]);
      });
      for (var v = 0; v < 2; v++) {
        boxes.forEach(function (x) {
          var m = x[0], b = x[1], cs, n, d;
          /* Omgång 60: både blocket och grannen mäts på det som syns (kant(), nedan), så två
             block som båda vill ha 0 px mäter samma skarv och inte motverkar varandra. */
          var wT = m.hasAttribute('data-sp-t') ? +m.getAttribute('data-sp-t') : null;
          if (wT !== null && (n = sib(b, -1))) {
            cs = parseFloat(getComputedStyle(b).marginTop) || 0;
            d = kant(m, 'top') - kant(n, 'bottom');
            b.style.marginTop = (cs + wT - d) + 'px';
            if (wT === 0) { n.classList.add('on-sp-noline-b'); b.classList.add('on-sp-noline'); }
          }
          var want = m.hasAttribute('data-sp-f') ? 0 : (m.hasAttribute('data-sp-b') ? +m.getAttribute('data-sp-b') : null);
          if (want !== null && (n = sib(b, 1))) {
            cs = parseFloat(getComputedStyle(b).marginBottom) || 0;
            d = kant(n, 'top') - kant(m, 'bottom');
            b.style.marginBottom = (cs + want - d) + 'px';
            /* Omgång 57: kant i kant (0 px) tar bort grannens kantlinje överst; omgång 60 också
               blockets egen kantlinje under. */
            if (want === 0) { n.classList.add('on-sp-noline'); b.classList.add('on-sp-noline-b'); }
          }
        });
      }
    }
    /* Det som syns av ett element (omgång 57 för blocket, omgång 60 även för grannen): ett
       element med bakgrund, skugga, kant på den sidan, text, bild eller fält syns med hela sin
       ruta; annars räknas bara barnen. Genomskinlig utfyllnad och marginal räknas alltså inte
       (försäkringsrutans 8 px marginal, social proof-radens 8 px utfyllnad, upsellens 6 px). */
    function syns(el, side) {
      var cs = getComputedStyle(el), bg = cs.backgroundColor;
      if ((bg && bg !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(bg)) || cs.backgroundImage !== 'none' || cs.boxShadow !== 'none') return true;
      if (parseFloat(side === 'top' ? cs.borderTopWidth : cs.borderBottomWidth) > 0 && cs.borderStyle !== 'none') return true;
      if (/^(IMG|SVG|svg|INPUT|BUTTON|SELECT|TEXTAREA|PROGRESS|VIDEO|CANVAS|IFRAME)$/.test(el.tagName)) return true;
      for (var i = 0; i < el.childNodes.length; i++) { var c = el.childNodes[i]; if (c.nodeType === 3 && c.textContent.trim()) return true; }
      return false;
    }
    function kant(el, side, d) {
      d = d || 0;
      var r = el.getBoundingClientRect();
      if (d > 8 || syns(el, side)) return side === 'top' ? r.top : r.bottom;
      var best = null;
      for (var i = 0; i < el.children.length; i++) {
        var k = el.children[i];
        if (!vis(k) || getComputedStyle(k).position === 'absolute' || getComputedStyle(k).position === 'fixed') continue;
        var e = kant(k, side, d + 1);
        if (best === null || (side === 'top' ? e < best : e > best)) best = e;
      }
      return best === null ? (side === 'top' ? r.top : r.bottom) : best;
    }
    function later() { [0, 250, 900, 2500].forEach(function (ms) { setTimeout(check, ms); }); }
    /* Omgång 86: den snabba varukorgen mäter direkt när den lagt in lådan, och efter varje morph
       (assets/section-renderer.js) mäts lådan i samma bildruta (ingen hoppande ruta). */
    window.__onCartSpacing = check;
    (window.__onAfterMorph = window.__onAfterMorph || []).push(function (el) { if (el && el.querySelector && el.querySelector('cart-items-component')) check(); });
    document.addEventListener('cart:update', later);
    /* Horizons dialog skickar dialog:open när lådan öppnas, oavsett hur. */
    document.addEventListener('dialog:open', later, true);
    document.addEventListener('shopify:section:load', later);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('cart-icon, .header-actions__cart-icon, [href$="/cart"], button[name="add"], cart-drawer-component')) later();
    }, true);
    later();
  })();
  } catch(e) { console.error(e); }
})();

})();
